import {
  queryTyreFeedback,
  tyreFeedbackSubmit,
  queryScanException,
  exportScanException,
  exportTyreFeedback,
  updateStoreRecordStatus,
  storeOutSupplement,
  queryqueryManufacturers,
  generateCode,
  exportStoreScanRecord
} from "@/graphql/wtK2Scan.gql";

import { resRest } from "@root/lib/utils";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    // 出库类型 -- 数组
    outTypeList: [
      {
        label: "无质保卡出库",
        value: "0"
      },
      {
        label: "质保卡出库",
        value: "1"
      }
    ],
    // 市场类型 -- 数组
    marketList: [
      {
        label: "PCR",
        value: "PCR"
      },
      {
        label: "TBR",
        value: "TBR"
      }
    ],
    // 出入库状态列表
    inOutStatusList: [
      {
        label: "异常审核",
        value: "0"
      },
      {
        label: "已生效",
        value: "1"
      },
      {
        label: "已退回",
        value: "2"
      },
      {
        label: "已失效",
        value: "3"
      },
      {
        label: "待确认",
        value: "4"
      }
    ],
    // 扫码类型 -- 数组
    scanTypeList: [
      {
        value: "1",
        label: "手工输入"
      },
      {
        value: "0",
        label: "扫码识别"
      }
    ],
    // 扫码异常类型 -- 数组
    exceptionTypeList: [
      {
        value: "1",
        label: "胎号不存在"
      },
      {
        value: "2",
        label: "渠道不匹配"
      },
      {
        value: "3",
        label: "其他"
      },
      {
        value: "4",
        label: "不在门店范围内"
      },
      {
        value: "5",
        label: "轮胎被冒领"
      }
    ],
    // 审核状态 -- 数组
    examineStatusList: [
      {
        value: 0,
        label: "待审核"
      },
      {
        value: 1,
        label: "已审核"
      }
    ],
    // 审核结果
    detailStatusObj: {
      1: "已通过",
      2: "已拒绝"
    },

    isK1Obj: {
      0: "非正规渠道",
      1: "正规渠道"
    },
    // 有效入库
    takeEffectObj: {
      0: "否",
      1: "是"
      // 0: "待确认",
      // 1: "有效",
      // 2: "已退回",
      // 3: "无效",
      // 4: "待确认"
    },
    storeAreaObj: {
      0: "超出门店范围",
      1: "门店范围内",
      2: "其他"
    },
    // systemTypeObj: {
    //   1: "App",
    //   2: "微信",
    //   3: "k1扫码枪",
    //   4: "系统后台"
    // },
    // 异常扫码类型 -- 数组
    exceptionScanTypeList: [
      {
        value: "2",
        label: "入库扫码"
      },
      {
        value: "1",
        label: "出库扫码"
      }
    ],
    inputMode: {
      1: "手动输入",
      2: "扫码输入"
    }
  },
  getters: {
    // 出库类型 -- 对象
    outTypeListObj(state) {
      let result = {};
      state.outTypeList.forEach(_ => {
        result[_.value] = _.label;
      });
      return result;
    },
    // 市场类型 -- 对象
    marketListObj(state) {
      let result = {};
      state.marketList.forEach(_ => {
        result[_.value] = _.label;
      });
      return result;
    },
    // 出入库状态 -- 对象
    inOutStatusListObj(state) {
      let result = {};
      state.inOutStatusList.forEach(_ => {
        result[_.value] = _.label;
      });
      return result;
    },
    // 扫码类型 -- 对象
    scanTypeListObj(state) {
      let result = {};
      state.scanTypeList.forEach(_ => {
        result[_.value] = _.label;
      });
      return result;
    },
    // 扫码异常类型 -- 对象
    exceptionTypeObj(state) {
      let result = {};
      state.exceptionTypeList.forEach(_ => {
        result[_.value] = _.label;
      });
      return result;
    },
    // 审核状态 -- 对象
    examineStatusObj(state) {
      let result = {};
      state.examineStatusList.forEach(_ => {
        result[_.value] = _.label;
      });
      return result;
    },
    // 异常扫码类型 -- 对象
    exceptionScanTypeObj(state) {
      let result = {};
      state.exceptionScanTypeList.forEach(_ => {
        result[_.value] = _.label;
      });
      return result;
    }
  },
  actions: {
    async queryInoutInventory({ state, dispatch }, params) {
      const statusList = await dispatch(
        "common/queryDataDictionaryListLang",
        { statePath: "inoutInventoryList", ddCode: "INOUT_INVENTORY_STATUS" },
        {
          root: true
        }
      );
      // update state
      state.inOutStatusList = statusList;
    },
    async queryTyreFeedback({ rootState }, params) {
      let {
        data,
        data: {
          api: {
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryTyreFeedback,
        variables: params
      });

      return { list: resRest(data), total };
    },
    async tyreFeedbackSubmit({ commit, state, rootState }: any, data?: any) {
      await rootState.gql.mutate({
        mutation: tyreFeedbackSubmit,
        variables: data
      });
    },
    async queryScanException({ rootState }, params) {
      let {
        data,
        data: {
          api: {
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryScanException,
        variables: params
      });

      return { list: resRest(data), total };
    },
    async exportScanException({ rootState }, params) {
      let res = await rootState.gql.query({
        query: exportScanException,
        variables: params
      });
    },
    async exportTyreFeedback({ rootState }, params) {
      let res = await rootState.gql.query({
        query: exportTyreFeedback,
        variables: params
      });
    },

    async updateStoreRecordStatus(
      { commit, state, rootState }: any,
      data?: any
    ) {
      await rootState.gql.mutate({
        mutation: updateStoreRecordStatus,
        variables: data
      });
    },
    async storeOutSupplement({ commit, state, rootState }: any, data?: any) {
      await rootState.gql.mutate({
        mutation: storeOutSupplement,
        variables: data
      });
    },
    async queryqueryManufacturers({ rootState }, params) {
      let res = await rootState.gql.query({
        query: queryqueryManufacturers,
        variables: params
      });
      return res.data.queryqueryManufacturers;
    },
    async generateCode({ rootState }, params) {
      let res = await rootState.gql.query({
        query: generateCode
      });

      return res.data.generateCode;
    },
    async exportStoreScanRecord({ rootState }, params) {
      await rootState.gql.query({
        query: exportStoreScanRecord,
        variables: params
      });
    }
  },
  mutations: {}
};
